import React, { createContext, ReactNode, useContext } from 'react';
import { IOrderSimulateState } from '../store/ducks/order-simulate-checkout-mvp/types';
import { ELocalStorageKey } from '../services/EGerdauService/types';

interface CheckoutProps {
  checkoutData?: IOrderSimulateState;
  updateCheckoutData: (state: IOrderSimulateState) => IOrderSimulateState;
}

const defaultCheckout: CheckoutProps = {
  checkoutData: undefined,
  updateCheckoutData: (state: IOrderSimulateState) => state
};

const CheckoutContext = createContext<CheckoutProps>(defaultCheckout);

export const CheckoutProvider = ({ children }: { children: ReactNode }) => {
  const [checkoutData, setCheckoutData] = React.useState<IOrderSimulateState>(
    localStorage.getItem(ELocalStorageKey.CHECKOUT)
      ? JSON.parse(localStorage.getItem(ELocalStorageKey.CHECKOUT) || '')
      : ''
  );

  const updateCheckoutData = (state: IOrderSimulateState) => {
    if (!state) {
      return state;
    }

    localStorage.setItem(ELocalStorageKey.CHECKOUT, JSON.stringify(state));
    setCheckoutData(state);
    return state;
  };

  return (
    <CheckoutContext.Provider
      value={{
        checkoutData,
        updateCheckoutData
      }}
    >
      {children}
    </CheckoutContext.Provider>
  );
};

export const useCheckout = () => useContext(CheckoutContext);
